import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { getWaitingPeriod, calculateIncreaseReadiness } from '../../utils/creditIncreaseWaitingPeriods';
import './CreditIncreaseStatusBar.css';

function CreditIncreaseStatusBar({ card }) {
  const t = useTranslation();
  if (!card) return null;
  
  // Get waiting period for the bank
  const waitingPeriodMonths = getWaitingPeriod(card.bankName);
  
  // Calculate readiness
  const readiness = calculateIncreaseReadiness(
    card.lastCreditIncreaseDate || card.dateCreated,
    card.dateCreated,
    waitingPeriodMonths
  );
  
  // Format the status text
  const getStatusText = () => {
    if (readiness.status === 'unknown') {
      return t('creditCardsInventory.dateNotAvailable');
    }
    
    if (readiness.isReady) {
      return t('creditCardsInventory.readyForIncrease');
    } else if (readiness.daysRemaining > 0) {
      const monthsRemaining = Math.floor(readiness.daysRemaining / 30);
      const daysRemaining = Math.ceil(readiness.daysRemaining % 30);
      if (monthsRemaining > 0) {
        if (daysRemaining > 0) {
          return t('creditCardsInventory.monthsDaysRemaining')
            .replace('{months}', monthsRemaining.toString())
            .replace('{plural}', monthsRemaining > 1 ? 's' : '')
            .replace('{days}', daysRemaining.toString())
            .replace('{plural2}', daysRemaining > 1 ? 's' : '')
            .replace('{plural2}', daysRemaining > 1 ? 's' : '');
        } else {
          return t('creditCardsInventory.monthsRemaining')
            .replace('{months}', monthsRemaining.toString())
            .replace('{plural}', monthsRemaining > 1 ? 's' : '')
            .replace('{plural2}', monthsRemaining > 1 ? 's' : '');
        }
      } else {
        return t('creditCardsInventory.daysRemaining')
          .replace('{days}', daysRemaining.toString())
          .replace('{plural}', daysRemaining > 1 ? 's' : '')
          .replace('{plural2}', daysRemaining > 1 ? 's' : '');
      }
    } else {
      return t('creditCardsInventory.readyForIncrease');
    }
  };
  
  return (
    <div className="credit-increase-status-bar">
      <div className="status-bar-header">
        <span className="status-bar-label">{t('creditCardsInventory.creditIncreaseReadiness')}</span>
        <span className="status-bar-text" style={{ color: readiness.color }}>
          {getStatusText()}
        </span>
      </div>
      <div className="status-bar-container">
        <div 
          className="status-bar-fill"
          style={{
            width: `${readiness.percentage}%`,
            backgroundColor: readiness.color,
          }}
        />
      </div>
      <div className="status-bar-footer">
        <span className="status-bar-info">
          {t('creditCardsInventory.waitingPeriod')
            .replace('{months}', waitingPeriodMonths.toString())
            .replace('{plural}', waitingPeriodMonths > 1 ? 's' : '')}
        </span>
      </div>
    </div>
  );
}

export { CreditIncreaseStatusBar };
export default CreditIncreaseStatusBar;
